import React from 'react';
import { Box, Grid } from '@nextiva/next-ui-components';
import * as UserTypes from 'types/User';
import * as LicenseTypes from 'types/License';
import * as RoleTypes from 'types/Role';
import * as LaunchpadConstants from 'constants/launchpad';
import * as LaunchpadTypes from 'types/Launchpad';
import { LaunchpadHeader } from './Header/Header';
import { LaunchpadBanner } from './Banner/Banner';
import { LaunchpadGrid } from './Grid/Grid';
import { LaunchpadAlert } from './Alert/Alert';
import PhoneImage from './phone-image.svg';

interface LaunchpadProps {
  featureState: Record<PropertyKey, any>;
  gridTileDefs: LaunchpadTypes.GridTileDef[];
  isVoiceAccount: boolean;
  licenses: LicenseTypes.License[];
  roles: RoleTypes.Role[];
  userPermissions: RoleTypes.Permissions[];
  isQueryError: boolean;
  user: UserTypes.User;
}

export const Launchpad = ({
  featureState,
  gridTileDefs,
  isVoiceAccount,
  licenses,
  roles,
  userPermissions,
  isQueryError,
  user,
}: LaunchpadProps) => {
  const { connect: isConnectFeatureFlagEnabled } = featureState;

  const isUserAccountConnectEnabled = user.accountInfo?.connectAccount;

  const connectLicense = licenses.find((l) =>
    l.features.find((f) => f === LaunchpadConstants.CONNECT_FEATURE_NAME),
  );

  const isUserConnectAccountWithLicense =
    isUserAccountConnectEnabled && connectLicense;

  const shouldShowConnectContent =
    isConnectFeatureFlagEnabled && isUserConnectAccountWithLicense;

  const headerTitle = LaunchpadConstants.headerTitleCreator(user.firstName);

  const headerSubTitle = shouldShowConnectContent
    ? LaunchpadConstants.HEADER_SUBTITLE_WITH_CONNECT_LICENSE
    : LaunchpadConstants.HEADER_SUBTITLE_WITHOUT_CONNECT_LICENSE;

  return (
    <>
      <LaunchpadAlert
        featureState={featureState}
        isQueryError={isQueryError}
        isVoiceAccount={isVoiceAccount}
        userPermissions={userPermissions}
        roles={roles}
        user={user}
      />
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <LaunchpadHeader subtitle={headerSubTitle} title={headerTitle} />
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {shouldShowConnectContent ? null : <PhoneImage />}
          </Box>
        </Grid>
      </Grid>
      {shouldShowConnectContent ? (
        <>
          <Box
            sx={{
              marginBottom: '40px',
            }}
          />
          <LaunchpadBanner connectLicense={connectLicense} />
        </>
      ) : null}
      <Box
        sx={{
          marginBottom: '40px',
        }}
      />
      <LaunchpadGrid tileDefs={gridTileDefs} />
    </>
  );
};
